import React, { useEffect, useState } from "react";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import { invoiceVerifyDetail } from "../../../redux/actions/invoiceVerificationAction";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import ArrowUp from "../../../assets/icons/indicator-up.svg";
import ArrowDown from "../../../assets/icons/indicator-down.svg";
import DetailsComponent from "../../../components/invoice-verification/details-component";
import { getFileExtension } from "../../../components/utilites/helper";
import InvoiceImageOptions from "../../invoice-verification/invoice-image-view/invoice-image-options";
import back from "../../../assets/icons/back.svg";
import ProductsTable from "../../invoice-verification/products-table";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import FlagInvoiceModal from "../../../components/modals/invoice-verification/flag-invoice-modal";
import { aiVerifiedInvoiceDetail } from "../../../redux/actions/invoice-verification-v2-actions";

const AiVerifiedInvoiceView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [invoiceViewData, setInvoiceViewData] = useState([]);
  const [invoiceOrderData, setInvoiceOrderData] = useState([]);
  const [openDetails, setOpenDetails] = useState([]);
  const [flagInvoiceModal, setFlagInvoiceModal] = useState(false);

  useEffect(() => {
    dispatch(aiVerifiedInvoiceDetail({ id: params.id }, onSuccess, onError));
    setLoading(true);
  }, [params.id]);

  const onSuccess = (data) => {
    setInvoiceViewData(data?.data?.data?.invoice);
    setInvoiceOrderData(data?.data?.data?.order?.orderProducts);
    setLoading(false);
  };

  const onError = (err) => {
    console.log(err);
    setLoading(false);
  };

  const distributorData = [
    {
      heading: "Distributor ID",
      title: invoiceViewData?.distributor?.distributor_id
        ? invoiceViewData?.distributor?.distributor_id
        : "--",
    },
    {
      heading: "Firm Name",
      title: invoiceViewData?.distributor?.firm_name
        ? invoiceViewData?.distributor?.firm_name
        : "--",
    },
    {
      heading: "Mobile Number",
      title: invoiceViewData?.distributor?.mobile
        ? invoiceViewData?.distributor?.mobile
        : "--",
    },
    {
      heading: "GST Number",
      title: invoiceViewData?.distributor?.gst_number
        ? invoiceViewData?.distributor?.gst_number
        : "--",
    },
    {
      heading: "Address",
      title: `${
        invoiceViewData?.distributor?.address?.address_one
          ? invoiceViewData?.distributor?.address?.address_one
          : "--"
      } ${invoiceViewData?.distributor?.address?.address_two ? "," : ""} ${
        invoiceViewData?.distributor?.address?.address_two
          ? invoiceViewData?.distributor?.address?.address_two
          : ""
      }${invoiceViewData?.distributor?.address?.address_three ? "," : ""} ${
        invoiceViewData?.distributor?.address?.address_three
          ? invoiceViewData?.distributor?.address?.address_three
          : ""
      }`,
    },
    {
      heading: "state",
      title: invoiceViewData?.distributor?.state?.name
        ? invoiceViewData?.distributor?.state?.name
        : "--",
    },
    {
      heading: "City",
      title: invoiceViewData?.distributor?.city?.name
        ? invoiceViewData?.distributor?.city?.name
        : "--",
    },
  ];

  const customerData = [
    {
      heading: "Jivini’s Customer Code",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.code
          ? invoiceViewData?.doctor?.code
          : "--"
        : invoiceViewData?.pharmacy?.code
        ? invoiceViewData?.pharmacy?.code
        : "--",
    },
    {
      heading: "Customer Name",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.name
          ? invoiceViewData?.doctor?.name
          : "--"
        : invoiceViewData?.pharmacy?.pharmacy_name
        ? invoiceViewData?.pharmacy?.pharmacy_name
        : "--",
    },
    {
      heading: "Customer Type",
      title: invoiceViewData?.doctor
        ? "Doctor"
        : invoiceViewData?.customer_type == "pharmacy"
        ? "Pharmacy"
        : "--",
    },
    {
      heading: "Pharmacy Type",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.pharmacy_type
          ? invoiceViewData?.doctor?.pharmacy_type
          : "--"
        : invoiceViewData?.pharmacy?.pharmacy_type
        ? invoiceViewData?.pharmacy?.pharmacy_type
        : "--",
    },
    {
      heading: "City",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.city?.name
          ? invoiceViewData?.doctor?.city?.name
          : "--"
        : invoiceViewData?.pharmacy?.city?.name
        ? invoiceViewData?.pharmacy?.city?.name
        : "--",
    },
    {
      heading: "Mobile Number",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.mobile
          ? invoiceViewData?.doctor?.mobile
          : "--"
        : invoiceViewData?.pharmacy?.mobile
        ? invoiceViewData?.pharmacy?.mobile
        : "--",
    },
    {
      heading: "GST Number",
      title: invoiceViewData?.pharmacy?.gst_number
        ? invoiceViewData?.pharmacy?.gst_number
        : "--",
    },
    {
      heading: "Address",
      title: invoiceViewData?.doctor
        ? ` ${
            invoiceViewData?.doctor?.address?.address_one
              ? invoiceViewData?.doctor?.address?.address_one
              : "--"
          } ${invoiceViewData?.doctor?.address?.address_two ? "," : ""} ${
            invoiceViewData?.doctor?.address?.address_two
              ? invoiceViewData?.doctor?.address?.address_two
              : ""
          }${invoiceViewData?.doctor?.address?.address_three ? "," : ""} ${
            invoiceViewData?.doctor?.address?.address_three
              ? invoiceViewData?.doctor?.address?.address_three
              : ""
          }`
        : ` ${
            invoiceViewData?.pharmacy?.address?.address_one
              ? invoiceViewData?.pharmacy?.address?.address_one
              : "--"
          } ${invoiceViewData?.pharmacy?.address?.address_two ? "," : ""} ${
            invoiceViewData?.pharmacy?.address?.address_two
              ? invoiceViewData?.pharmacy?.address?.address_two
              : ""
          }${invoiceViewData?.pharmacy?.address?.address_three ? "," : ""} ${
            invoiceViewData?.pharmacy?.address?.address_three
              ? invoiceViewData?.pharmacy?.address?.address_three
              : ""
          }`,
    },
  ];

  const orderData = [
    {
      heading: "Order ID",
      title: invoiceViewData?.order?.order_id ?? "--",
    },
    {
      heading: "Order Date",
      title: invoiceViewData?.order?.createdAt
        ? moment(invoiceViewData?.order?.createdAt).format(
            "DD MMM YYYY HH:mm A"
          )
        : "--",
    },
    {
      heading: "Order Value",
      title: invoiceViewData?.order?.total
        ? `₹ ${invoiceViewData?.order?.total}`
        : "--",
    },
    {
      heading: "Order Status",
      title: invoiceViewData?.order?.status
        ? invoiceViewData?.order?.status
        : "--",
    },
    {
      heading: "Delivered  Date",
      title: invoiceViewData?.order?.delivery_date
        ? moment(invoiceViewData?.delivery_date).format("DD MMM YYYY HH:mm A")
        : "--",
    },
  ];

  const distributoInvoiceDetails = [
    {
      heading: "Distributor Invoice Id",
      title: invoiceViewData?.invoice_id ? invoiceViewData?.invoice_id : "--",
    },
    {
      heading: "Distributor Invoice Date",
      title: invoiceViewData?.invoice_date
        ? invoiceViewData?.invoice_date &&
          moment(invoiceViewData?.invoice_date).format("DD MMM YYYY HH:mm A")
        : "--",
    },
    {
      heading: "Invoice Value",
      title: invoiceViewData?.order?.total
        ? `₹ ${invoiceViewData?.order?.total}`
        : "--",
    },
  ];

  const Breadcrumb = ({ match }) => (
    <span>
      {match?.route?.path?.endsWith("view/:id") &&
        (invoiceViewData?.distributor?.distributor_id
          ? ` / ${invoiceViewData?.distributor?.distributor_id} - view`
          : " / view")}
    </span>
  );
  return (
    <MainLayout breadcrumbData={Breadcrumb}>
      <FlagInvoiceModal
        show={flagInvoiceModal}
        handleClose={() => setFlagInvoiceModal(false)}
      />
      <div className="search-container d-flex justify-content-between ">
        <div
          className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
          onClick={() => navigate(-1)}
        >
          <img src={back} alt="back_btn" />
          <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
            BACK
          </span>
        </div>
        <AdminButton
          type="button"
          background="#7065E4"
          color="white"
          width="150px"
          style={{
            textTransform: "uppercase",
          }}
          onClick={() => {
            setFlagInvoiceModal(true);
          }}
        >
          <span className="m-2">Flag Invoice</span>
        </AdminButton>
      </div>
      <div className="d-flex" style={{ height: "90vh", overflow: "hidden" }}>
        <div
          className="p-4"
          style={{
            width: "50%",
            overflowY: "auto",
          }}
        >
          <DetailsComponent
            title="Distributor Details"
            data={distributorData}
            openDetails={openDetails}
            setOpenDetails={setOpenDetails}
            keyWord={"Distributor"}
          />
          <DetailsComponent
            title="Customer Details"
            data={customerData}
            openDetails={openDetails}
            setOpenDetails={setOpenDetails}
            keyWord={"Customer"}
          />
          <DetailsComponent
            title="Order Details"
            data={orderData}
            openDetails={openDetails}
            setOpenDetails={setOpenDetails}
            keyWord={"Order"}
          />
          <DetailsComponent
            title="Distributor invoice Details"
            data={distributoInvoiceDetails}
            openDetails={openDetails}
            setOpenDetails={setOpenDetails}
            keyWord={"invoice_Details"}
          />
          <div className="my-4">
            <div
              onClick={() => {
                if (openDetails.includes("Product")) {
                  setOpenDetails(
                    openDetails.filter((item) => item !== "Product")
                  );
                } else {
                  setOpenDetails([...openDetails, "Product"]);
                }
              }}
              className="invoice-basic-details-container my-auto d-flex justify-content-between align-items-center cursor_pointer px-3"
            >
              <label className="basic-title">Product Details</label>
              <div>
                <span>
                  {openDetails.includes("Product") ? (
                    <img src={ArrowDown} />
                  ) : (
                    <img src={ArrowUp} />
                  )}
                </span>
              </div>
            </div>
            {openDetails.includes("Product") && (
              <div className="my-4 px-2">
                <ProductsTable
                  data={invoiceOrderData}
                  distributorProductTable={
                    invoiceViewData?.distributorInvoiceProducts
                  }
                  total={invoiceViewData?.order?.total}
                  distributor={invoiceViewData?.distributor?.firm_name}
                />
              </div>
            )}
          </div>
        </div>

        <div
          className="p-4"
          style={{
            width: "50%",
            overflowY: "auto",
            position: "relative",
          }}
        >
          <div className="mx-auto mt-4">
            <label className="color_747f9e text-nowrap fs_14 fw_500">
              Invoice By
            </label>
            <p className="fs_15 fn_Nunito fw_500 text-capitalize">
              Distributor
            </p>
          </div>

          <div
            style={{
              position: "sticky",
              top: "1rem",
              zIndex: 10,
              background: "rgba(231, 229, 255, 0.35)",
              border: "2px solid #7065e4",
              borderRadius: "10px",
              height: "70.5vh",
            }}
          >
            {invoiceViewData?.url &&
            getFileExtension(invoiceViewData?.url) === "pdf" ? (
              <div style={{ borderRadius: "10px", height: "70vh" }}>
                <iframe
                  src={invoiceViewData?.url}
                  className="w-100 h-100"
                  style={{ borderRadius: "10px", border: "none" }}
                />
              </div>
            ) : (
              <InvoiceImageOptions image={invoiceViewData?.url} />
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AiVerifiedInvoiceView;
